import { type ReactNode } from 'react'
import { motion, useReducedMotion } from 'framer-motion'
import { smoothEase } from '@/lib/motion'

type FadeInProps = {
  children: ReactNode
  className?: string
  delay?: number
  /** Slightly larger vertical travel */
  y?: number
}

/** Scroll-triggered fade for sections (disabled when reduced motion is on). */
export function FadeIn({ children, className, delay = 0, y = 20 }: FadeInProps) {
  const reduced = useReducedMotion()

  return (
    <motion.div
      className={className}
      initial={reduced ? false : { opacity: 0, y }}
      whileInView={reduced ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-48px' }}
      transition={{ duration: 0.5, delay, ease: smoothEase }}
    >
      {children}
    </motion.div>
  )
}
